
import React from "react";
import { Campaign } from "@/types/campaigns";
import { Badge } from "@/components/ui/badge";

interface CampaignProductInfoProps {
  campaign: Campaign;
}

const CampaignProductInfo = ({ campaign }: CampaignProductInfoProps) => {
  const getProductName = () => {
    return campaign.product === "cashback" ? "Cashback" : "Indique e Ganhe";
  };

  const getConfigurationType = () => {
    // Para produtos de cashback, verificar se usa configuração customizada
    if (campaign.product === "cashback" && campaign.use_custom_cashback) {
      return "Customizado";
    }
    
    // Para todos os outros casos (referral ou cashback padrão)
    return "Padrão";
  };

  const isCustomCashback = campaign.product === "cashback" && campaign.use_custom_cashback;

  return (
    <div className="space-y-1">
      <div className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
        {getProductName()}
      </div>
      
      <div className="flex items-center">
        <Badge 
          variant="outline" 
          className={`text-xs ${
            isCustomCashback 
              ? 'bg-purple-50 text-purple-700 border-purple-200' 
              : 'bg-gray-50 text-gray-700 border-gray-200'
          }`}
        >
          {getConfigurationType()}
        </Badge>
      </div>
    </div>
  );
};

export default CampaignProductInfo;
